<template>
<div id="app">
  <app-login v-if="!loggedIn && !isGuestConference"></app-login>
  <v-app v-if="isGuestConference"><app-conference></app-conference><call-session></call-session></v-app>
  <v-app id="inspire" v-if="loggedIn && !isGuestConference">
      <v-navigation-drawer
        v-model="drawer"
        disable-resize-watcher 
        app
      >
        <v-list>
          <v-list-item link v-on:click="$router.push('/dialer2')">
            <v-list-item-action>
              <v-icon>mdi-phone</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Calls</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link  v-on:click="$router.push('/conferences')">
            <v-list-item-action>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Conferences</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link v-on:click="$router.push('/chats')">
            <v-list-item-action>
              <v-icon>mdi-at</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Messages</v-list-item-title>
            </v-list-item-content>
          </v-list-item>


          <v-list-item link v-on:click="$router.push('/queues')">
            <v-list-item-action>
              <v-icon>mdi-headset</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Queues</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link  v-on:click="$router.push('/prefs')">
            <v-list-item-action>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="1==2" link  v-on:click="$router.push('/dev')" style='background-color: yellow'>
            <v-list-item-action>
              <v-icon>mdi-bug</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Debug</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-navigation-drawer>
  
      <v-app-bar
        app
        color="primary"
        dark
        dense
      >
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        
        <TopNavigation></TopNavigation>
        <v-spacer></v-spacer>
        <v-img src="logo_white_transparent.png"
          max-width="110"
        ></v-img>
      </v-app-bar>
      <call-session></call-session>
      <v-main class="pa-0">  
        <router-view></router-view>
      </v-main>
      
  </v-app>
  
  <!--
    PLEASE do not remove this from the source. If it is showing up in production,
    the deployment is being done incorrectly. Call Richard for suport (705)-388-2329.

    If you need it out of the way in dev, just click it. It will issue a warning, and then
    go away until you reload.
  -->
  <DeveloperModeWarning />
</div>
</template>

<script>
/* global $ */
import { mapState } from 'vuex';
import Dialer2 from './dialer2.vue'
import History from './history.vue'
import Pref from './preferences.vue'
import Voicemail from './voicemail.vue'
import Conferences from './conferences.vue'
import Chats from './chats.vue'
import Login from '../overlays/login.vue'
import Spinner from '../overlays/spinner.vue'
import Dev from './dev.vue'
import Calling from './calling.vue'
import Common from '../mixins/common.vue';
import TopNavigation from '../components/TopNavigation.vue';
import ConferenceWatch from '../mixins/conferencewatch.vue';
import Conference from './conference.vue';
import MinSession from '../components/MinSession.vue';
import { CancelUserAgentClient } from 'sip.js/lib/core';
import DeveloperModeWarning from '../components/DeveloperModeWarning.vue';
import { Invitation } from 'sip.js';

export default {
  mixins: [Common, ConferenceWatch],
  data: function() {
    return {
      drawer: false,
    };
  },
  computed: {
    loggedIn: function() {
      return(this.user!==undefined && this.user!==null);
    },
    isGuestConference: function() {
      if (this.$route.params.confId) {
        return true;
      }
    },
    ringtone: {
      get() {return this.$store.state.ringtone}
    },
    session: {
      get() { return this.$store.getters['sip/session'] },
    },
    state: {
      get: function() {
        if (this.session) {
          return this.session.state;
        }
        return null;
      }
    },
  },
  components: {
    'app-dialer': Dialer2,
    'app-voicemail': Voicemail,
    'app-history': History,
    'app-conferences': Conferences,
    'app-pref': Pref,
    'app-chats': Chats,
    'app-login': Login,
    'app-spinner': Spinner,
    'app-dev': Dev,
    'app-calling' : Calling,
    'TopNavigation': TopNavigation,
    'app-conference': Conference,
    'call-session': MinSession,
    DeveloperModeWarning
  },
  methods: {
    numSelected: function(num) {
	alert('number ' + num);
      // Select the tab first, because the number size will be incorrectly
      // calculated if the tab is not visible. FIXME: Get rid of this whole
      // method for resizing numbers.
      $('#dialer-tab').tab('show');
      this.number=''; // We blank the number first to make sure that it updates
      this.number=num;
    },
  },
  async mounted() {
  },
  watch: {
    state: function(newval, oldval) {
      // guard, because this function doesn't work without a ringtone
      if (!this.ringtone) return;
      if (newval == "Initial") {
        this.ringtone.audio.play();
        if (this.session instanceof Invitation /* incoming call */){
          if (!("Notification" in window)) {
            console.log("This browser does not support desktop notification");
          }

          // Let's check whether notification permissions have already been granted
          else if (Notification.permission === "granted") {
            console.log("creating notification")
            // If it's okay let's create a notification
            var notification = new Notification("Incoming Call from " + this.session.remoteIdentity.uri.user, {icon: "login/icon.png", silent: true});
            notification.onclick = function() {window.focus(); this.close;};
          }

          // Otherwise, we need to ask the user for permission
          else if (Notification.permission !== "denied") {
            Notification.requestPermission().then(function (permission) {
              // If the user accepts, let's create a notification
              if (permission === "granted") {
                var notification = new Notification("Hi there!");
              }
            });
          }
        }

      }
      else if (newval != "Initial" && newval != "Establishing"){
        this.ringtone.audio.pause();
        this.ringtone.audio.currentTime = 0.0;
      }
    }
  }
}

</script>

<style>

.center-pills {
  display: flex;
  justify-content: center;
}
.nav {
  position: fixed;
  top: 0;
  z-index: 4;
  width: 100%;
  background-color: #ddd;
}
.tab-content {
  position: fixed;
  top: 0px;
  bottom: 0px;
  overflow-y: scroll;
  margin-top: 40px;
  width: 100%;
}
.tab-link.active:not(.offline),
.tab-link.active:not(.online) {
  background-color: rgba(1,18,25,0.1);
}
.tab-link.offline {
  background-color: rgba(255,0,0,0.6);
}
.tab-link.offline.active {
  background-color: rgba(255,0,0,0.7);
}
.tab-link.online {
  background-color: rgba(0,255,0,0.25);
}
.tab-link.online.active {
  background-color: rgba(0,255,0,0.5);
}
.tab-link i {
  font-size: 24px;
  color: #fff;
}
.tab-link i.settings-icon {
  font-size: 26px;
  margin-top: -2px;
  margin-left: 2px;
}
.tab-link i.a {
  display: inline-block;
}
.tab-link i.b {
  display: none;
}
.tab-link.active i.a {
  display: none;
}
.tab-link.active i.b {
  display: inline-block;
}
.fw-flag {
  width: 44px;
  height: 34px;
  border: 1px solid #eee;
}
.phone-code-selection .item-title-row,
.language-selection .item-title-row {
  background-position-y: 10px !important;
}
.phone-code-selection .item-title-row .item-title span,
.language-selection .item-title-row .item-title span {
  display: block;
  font-size: 12px;
  color: #999;
}
.phone-code-selection .item-title-row .item-after,
.language-selection .item-title-row .item-after {
  position: relative;
  top: 11px;
}
.content-block-16-mar {
  margin: 16px 0;
}
#select-contact {
  position: relative;
}
#select-contact i {
  position: absolute;
  font-size: 18px;
  left: 10px;
  top: 50%;
  margin-top: -10px;
}
.phone-code-selection-area {
  margin-bottom: 0;
  margin-top: 0;
}
.phone-number-area {
  margin-top: -1px;
}
.phone-number-area ul:before {
  background: none;
  display: none;
}
.phone-number-area i {
  font-size: 26px;
  margin-left: 7px;
  margin-top: 5px;
}
.phone-info {
  border-radius: 3px;
  padding: 6px 0;
  text-align: center;
  color: #fff;
  position: relative;
}
.phone-info i,
.phone-info span {
  display: inline-block;
  vertical-align: middle;
  font-size: 16px;
}
.phone-info i {
  font-size: 23px;
  position: absolute;
  left: 5px;
  top: 50%;
  margin-top: -12px;
}
.phone-info.phone-good {
  background: #2196f3;
}
.phone-info.phone-good .icon-close {
  display: none;
}
.phone-info.phone-bad {
  background: #f44336;
}
.phone-info.phone-bad .icon-check {
  display: none;
}
.mar-topbot-8 {
  margin-top: 8px;
  margin-bottom: 8px;
}
.settings-icon {
  font-size: 35px;
  margin-left: 4px;
}
.settings-icon-mini {
  font-size: 25px;
  margin-left: 8px;
}
.help-request-item .item-title {
  padding-left: 6px;
}
.phone_number_input_wrap .item-media {
  width: 46px;
}
.custom {
  background: -webkit-linear-gradient(#007aff, #ffe600);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
